import React from 'react'
import { Button, Heading, Text } from '../../components/ui'

type ParametrosDeleteModalProps = {
  label: string
  deleteReason: string
  submitting: boolean
  onReasonChange: (value: string) => void
  onClose: () => void
  onConfirm: () => void
}

const ParametrosDeleteModal: React.FC<ParametrosDeleteModalProps> = ({
  label,
  deleteReason,
  submitting,
  onReasonChange,
  onClose,
  onConfirm,
}) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md mx-4 p-6">
      <Heading as="h3" size="2xl" className="text-gray-900 dark:text-white mb-2">
        Confirmar Exclusão
      </Heading>
      <Text size="sm" color="muted" className="mb-4">
        Você está excluindo: <strong className="text-gray-900 dark:text-white">{label}</strong>
        <br />
        O registro não será removido do banco de dados (exclusão lógica).
      </Text>

      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        Motivo da exclusão <span className="text-red-500">*</span>
      </label>
      <textarea
        rows={3}
        value={deleteReason}
        onChange={(e) => onReasonChange(e.target.value)}
        placeholder="Informe o motivo..."
        className="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 resize-none"
      />

      <div className="flex justify-end gap-3 mt-4">
        <Button variant="ghost" onClick={onClose} disabled={submitting}>
          Cancelar
        </Button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={submitting || !deleteReason.trim()}
          className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg disabled:opacity-50 transition-colors"
        >
          {submitting ? 'Excluindo...' : 'Confirmar Exclusão'}
        </button>
      </div>
    </div>
  </div>
)

export default ParametrosDeleteModal
